import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback } from "react";

import { addToast, nextId } from "shared/actions/toastActions";

import { useAppDispatch } from "store/hooks";

export const useCopyBlockId = () => {
  const dispatch = useAppDispatch();
  return useCallback(
    (block_id: number) => {
      navigator.clipboard
        .writeText(`block-${block_id}`)
        .then(() => {
          dispatch(
            addToast(
              {
                kind: "success",
                message: `Copied block-${block_id}`,
                removalTimeout: 2000,
              },
              nextId()
            )
          );
        })
        .catch(() => {
          dispatch(
            addToast(
              {
                kind: "danger",
                message: `Failed to copy block-${block_id}`,
              },
              nextId()
            )
          );
        });
    },
    [dispatch]
  );
};

const CopyBlockButton = ({ block_id }: { block_id: number }) => {
  const copyBlockId = useCopyBlockId();

  return (
    <button
      type="button"
      onClick={() => copyBlockId(block_id)}
      className="PWTable__actions__button pwButton--grey copyBlockButton"
      title={`Copy block-${block_id}`}
    >
      <FontAwesomeIcon icon="copy" />
    </button>
  );
};

export default CopyBlockButton;
